import { apiClient } from "./apiClient";

export const settingsService = {
  getSetting: async (setting) => {
    try {
      const response = await apiClient.get(`/settings/${setting}`);
      return response.data;
    } catch (error) {
      console.error("Error getting setting:", error);
      return null;
    }
  },

  updateSetting: async (setting, value) => {
    try {
      const response = await apiClient.post(`/settings/${setting}`, {
        value,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating setting:", error);
      return null;
    }
  },
};
